/** Metadatos de captación que no son campos del formulario de ficha. */
export const CAPTACION_EXTRAS_META_KEYS = new Set([
  "propietarios_ficha",
  "contactos_asociados_ficha",
  "superficies_ficha",
  "contacto_comunicacion_id",
  "propietario",
  "origen_multimedia",
  "subida_multimedia_pendiente",
  "multimedia_esperada_fotos",
  "multimedia_esperada_documentos",
  "multimedia_esperada_videos",
  "ficha_finalizada_pendiente_multimedia",
  "campos_listos_pendiente_multimedia",
  "estado_multimedia",
]);

const BOOLish = (v) => v === true || v === "true";

/** Campos de texto que deben restaurarse aunque estén vacíos (p. ej. observaciones borradas). */
const TEXT_FIELDS_ALLOW_EMPTY = new Set([
  "referencia",
  "eq_observaciones",
  "info_visita",
  "observaciones_internas",
  "alquiler_observaciones",
  "web_titulo",
  "web_desc_corta_es",
  "web_desc_larga_es",
  "motivo_no_disponible",
]);

function isBoolFormField(key) {
  if (key === "publicar_web" || key === "disponible" || key === "exclusiva" || key === "vpo" || key === "amueblado") return true;
  if (key === "referencia_manual" || key === "precio_web_consultar" || key === "codigo_postal_manual") return true;
  if (key === "acepta_mascotas" || key === "seguro_alquiler_contratado" || key === "aval_requerido") return true;
  return key.startsWith("eq_");
}

/**
 * Convierte datos_extras guardados en valores para `setForm`.
 * Complementa el mapeo explícito de columnas nativas (tipo, población, etc.).
 */
export function extrasCaptacionToFormPatch(extras) {
  if (!extras || typeof extras !== "object") return {};
  const out = {};
  for (const [k, v] of Object.entries(extras)) {
    if (CAPTACION_EXTRAS_META_KEYS.has(k)) continue;
    if (v === null || v === undefined) continue;
    if (typeof v === "boolean") {
      out[k] = v;
      continue;
    }
    if (typeof v === "string") {
      if (isBoolFormField(k) && (v === "true" || v === "false")) {
        out[k] = v === "true";
        continue;
      }
      if (v === "" && !TEXT_FIELDS_ALLOW_EMPTY.has(k) && !k.startsWith("web_desc_")) continue;
      out[k] = v;
      continue;
    }
    if (typeof v === "number" && !Number.isNaN(v)) {
      out[k] = v;
      continue;
    }
    if (Array.isArray(v) && (k === "ub_vistas_ids" || k === "garaje_tipos" || k === "garajes_plazas_detalle" || k === "cartel_opciones")) {
      out[k] = v;
    }
  }
  // Ampliar: UUID en eq_aire/calef → *_id; tipo real → Sí (ficha no debe mostrar No).
  // «No tiene» en *_id no fuerza Sí (antes el form quedaba en Sí sin tipo visible).
  const UUID_RX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  const ausenteNombre = (n) => {
    const s = String(n || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/\p{M}/gu, "")
      .trim();
    if (!s) return false;
    return (
      /^(no tiene|ninguno|ninguna|sin|n\/a|-)$/.test(s)
      || /^no tiene\b/.test(s)
      || /^sin\s+(aire|aa|a\.?\s*a\.?|calefaccion|calef\.?|piscina)/.test(s)
    );
  };
  for (const boolK of ["eq_aire", "eq_calefaccion", "eq_piscina_priv", "eq_piscina_comun"]) {
    const idK = `${boolK}_id`;
    const nombreK =
      boolK === "eq_aire"
        ? "aire_tipo_nombre"
        : boolK === "eq_calefaccion"
          ? "calefaccion_tipo_nombre"
          : null;
    if ((out[idK] == null || out[idK] === "") && out[boolK] != null && typeof out[boolK] === "string" && UUID_RX.test(out[boolK])) {
      out[idK] = out[boolK];
    }
    if (!out[idK]) continue;
    const nom = nombreK ? out[nombreK] : null;
    if (ausenteNombre(nom)) {
      out[boolK] = false;
      out[idK] = "";
      if (nombreK) delete out[nombreK];
      continue;
    }
    // Sin nombre en extras: asumir tipo real (Split…) → Sí; el select CRM filtra «No tiene»
    out[boolK] = true;
  }
  return out;
}

/** Normaliza booleans guardados como string en JSON legacy. */
export function normalizarBoolExtras(extras, keys) {
  const out = {};
  for (const k of keys) {
    if (extras[k] == null || extras[k] === "") continue;
    out[k] = BOOLish(extras[k]);
  }
  return out;
}
